import type { ReactNode } from 'react'

/**
 * Where a customer reaches us.
 *
 * ONE definition. The app told people to "contact support", "talk to us", "tell us" and "ask us" in a
 * dozen places -- to buy Monitor, to resume paused emails, to have data deleted -- and gave no address
 * anywhere, so every one of those instructions was a dead end. This is the address the published
 * privacy notice gives (docs/legal/privacy-notice.md) and the Reply-To on every email we send
 * (EmailOptions.ReplyTo); change it here and every link follows. It was contact@ until 2026-09-24,
 * when the owner settled on support@ -- which the emails were already replying to.
 */
export const SUPPORT_EMAIL = 'support@defenssive.com'

/** A mailto: for the support address, with a subject so a request arrives already labelled. */
export function supportMailto(subject?: string): string {
  return subject
    ? `mailto:${SUPPORT_EMAIL}?subject=${encodeURIComponent(subject)}`
    : `mailto:${SUPPORT_EMAIL}`
}

/** The support address as a link. Shows the address itself unless given other words. */
export function SupportLink({ subject, children }: { subject?: string; children?: ReactNode }) {
  return <a href={supportMailto(subject)}>{children ?? SUPPORT_EMAIL}</a>
}
